import React, { useState } from "react";

import img1 from "../../assets/images/layouts/about-01.png";
import img2 from "../../assets/images/layouts/about-02.png";
import img3 from "../../assets/images/layouts/about-03.png";

import img5 from "../../assets/images/layouts/about-05.png";
import Button from "../button/Button";

function About(props) {
  const [dataImg] = useState([
    {
      id: 1,
      img: img1,
      class: "img1",
    },
    {
      id: 2,
      img: img2,
      class: "img2",
    },
    {
      id: 3,
      img: img3,
      class: "img3",
    },
    // {
    //     id: 4,
    //     img : img4,
    //     class: 'img4'
    // },
    {
      id: 5,
      img: img5,
      class: "img5",
    },
  ]);

  const [dataBlock] = useState({
    subheading: "About me",
    heading: "Senior Full-Stack Engineer",
    desc1:
      "Hi, I'm Jacob Rajan, a Senior Full-Stack Engineer with 7+ years of experience building enterprise-grade web applications. I specialize in React, Next.js, and Node.js — delivering scalable, performant products across security platforms, device management systems, SaaS dashboards, and data-heavy interfaces.",
    desc2: "",
  });

  const [profile] = useState({
    title: "Senior Full-Stack Engineer",
    intro:
      "Hi, I'm Jacob Rajan. I specialize in React, Next.js, and Node.js with 7+ years of experience building enterprise applications focused on performance, security, and exceptional user experience.",
    details: {
      name: "Jacob Rajan",
      nationality: "Indian",
      phone: "+91 63815 19592",
      email: "imjacobrajan@gmail.com",
      experience: "7+ years",
      language: "English, Tamil",
    },
  });

  return (
    <section className="about">
      <div className="shape"></div>
      <div className="container">
        <div className="row rev">
          <div className="col-xl-6 col-md-12">
            <div className="about__right">
              <div className="images">
                {dataImg.map((idx) => (
                  <img
                    key={idx.id}
                    className={idx.class}
                    src={idx.img}
                    alt="cyfonii"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-md-12">
            <div className="block-text">
              <h6 className="sub-heading">
                <span>{dataBlock.subheading}</span>
              </h6>
              <h3 className="heading">{dataBlock.heading}</h3>
              <p className="mb-17">{dataBlock.desc1}</p>
              <p className="mb-26">{dataBlock.desc2}</p>
              <div className="row g-3 mb-5">
                {Object.entries(profile.details).map(([key, value]) => (
                  <div key={key} className="">
                    <div className="d-flex">
                      <span className="text-secondary w-25 text-capitalize">
                        {key}
                      </span>
                      <span className="ps-1 text-light">: {value}</span>
                    </div>
                  </div>
                ))}
              </div>
              <Button link="#" title="More About Me" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
